import * as React from 'react';
const SvgMetaSingleImage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    fill="none"
    viewBox="0 0 88 88"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#fff" fillOpacity={0.01} d="M0 0h88v88H0z" />
      <rect width={88} height={88} fill="#fff" rx={4} />
      <path
        fill="#16E"
        d="M4 28a2 2 0 0 1 2-2h76a2 2 0 0 1 2 2v40a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
        opacity={0.6}
      />
      <rect
        width={79}
        height={43}
        x={4.5}
        y={26.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={1.5}
      />
      <rect
        width={16}
        height={2}
        x={4}
        y={78}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={32}
        height={2}
        x={4}
        y={74}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={13}
        height={5}
        x={70.5}
        y={74.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={0.5}
      />
      <rect
        width={40}
        height={2}
        x={4}
        y={20}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={64}
        height={2}
        x={4}
        y={16}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={12}
        height={2}
        x={14}
        y={9}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={22}
        height={2}
        x={14}
        y={5}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.8}
        rx={1}
      />
      <rect
        width={8}
        height={8}
        x={4}
        y={4}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.8}
        rx={2}
      />
      <rect
        width={87}
        height={87}
        x={0.5}
        y={0.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={3.5}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h88v88H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMetaSingleImage;
